module.exports = __webpack_public_path__ + "img/esg-1.9d884279.png";